import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import { DragHandle } from './DragHandle';
export var SortableItem = SortableElement(SortableHandle(DragHandle));
